import { useEffect } from "react";
import { useRouter } from "next/router";

export default function Agriculture() {
  const router = useRouter();

  useEffect(() => {
    router.replace("/agriculture/maps");
  }, [router]);

  return null;
}
